<template>
  <modal
      @close="$emit('close')"
      classes="w-full lg:w-full mx-auto overflow-auto px-4 max-w-xsm lg:max-w-xm pb-4 bg-white"
  >
    <div class="mt-6 mb-8">
      <div class="-mt-4 flex">
        <h1 class="header">Фильтры</h1>
        <button @click="setDefaultFilters" class="clear-all-filters text-additional-text ml-4 pt-2">Сбросить все
        </button>
      </div>

      <!-- filter by city button -->
      <div>
        <button class="filter-by-city mt-4">
          По городу
          <img class="ml-1" src="@/assets/arrow-down-filter-modal.svg" alt/>
        </button>
      </div>

      <!-- show selected cities -->
      <div class="show-selected-cities flex" v-if="selectedCities.length != 0">
        <div
            class="flex mr-3"
            v-for="(city, index) in selectedCities"
            :key="index"
        >
          <!-- <p class="mr-1">Город:</p> -->
          <p :class="{'mr-3':city.name !== 'Все города'}">{{ city.name }}</p>
          <img
              v-if="city.name !== 'Все города'"
              @click="removeCity(city)"
              src="@/assets/SVG/cross-partners.svg"
              alt
          />
        </div>
      </div>

      <!-- search and select a city -->
      <div class="mt-8 city-selection">
        <div class="relative">
          <!-- search input -->
          <div class="search-input">
            <input
                type="search"
                class="bg-white rounded p-3 w-full text-main-text"
                placeholder="Поиск"
                v-model="searchKeyword"
                style="outline:none;
                    font-family: Montserrat;
                     font-style: normal;
                     font-weight: normal;
                     font-size: 14px;
                     line-height: 17px;"
                @click="showBox = true"
            />
            <div class="absolute pin-t mt-3 mr-4 text-purple-lighter pin-r">
              <svg
                  class="h-4 text-dark"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 52.966 52.966"
                  style="enable-background:new 0 0 52.966 52.966; color:red"
                  xml:space="preserve"
                  fill="#979797"
              >
                <path
                    d="M51.704,51.273L36.845,35.82c3.79-3.801,6.138-9.041,6.138-14.82c0-11.58-9.42-21-21-21s-21,9.42-21,21s9.42,21,21,21
                  c5.083,0,9.748-1.817,13.384-4.832l14.895,15.491c0.196,0.205,0.458,0.307,0.721,0.307c0.25,0,0.499-0.093,0.693-0.279
                  C52.074,52.304,52.086,51.671,51.704,51.273z M21.983,40c-10.477,0-19-8.523-19-19s8.523-19,19-19s19,8.523,19,19
                  S32.459,40,21.983,40z"
                />
              </svg>
            </div>
          </div>
          <!-- show options -->
          <div class="show-box-outer">
            <div
                ref="showBox"
                class="show-box-inner mb-5 items-center py-1 max-h-third-screen overflow-y-auto"
                v-show="showBox"
            >
              <div
                  class="select-Item flex w-full py-2 flex-row justify-between px-4 cursor-pointer select-none font-medium selectedLabel options"
                  v-for="(city, index) in allCities"
                  :key="index"
                  :class="{ 'selected-city': highlightSelectedCities(city) }"
                  @click="addCity(city)"
              >
                <p>{{ city.name }}</p>
                <img class="ml-1" src="@/assets/checked-option-white.svg" alt/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import modal from '@/views/modals/new-base-modal.vue';
import isMobile from '@/mixins/isMobile';
import base from '@/clients/base';
import { mapActions } from 'vuex';

export default {
  name: 'rating-filter-modal',
  mixins: [isMobile],
  components: {
    modal,
  },
  data() {
    return {
      searchKeyword: '',
      showBox: true,
      allCities: [],
    };
  },
  created() {
    base.get('api/cities/all?sort=name,id').then((response) => {
      // this.allCities.push(response.data.data)
      this.allCities = response.data.data;
      this.allCities.unshift({ id: '', name: 'Все города' });
    });
  },
  computed: {
    selectedCities() {
      return this.$store.state.ratingTable.selectedCities;
    },
    isPhone() {
      return this.isMobile;
    },
    city() {
      return this.$store.getters.cityProps.city || '';
    },
    cityId() {
      return this.$store.getters.cityProps.id || '';
    },
  },
  methods: {
    ...mapActions([
      'addCitytoFilter',
      'removeCityFromFilter',
      'removeAllFilters',
      'addDefaultCitytoFilter',
    ]),
    highlightSelectedCities(city) {
      return this.selectedCities.map(e => e.name).indexOf(city.name) != -1;
    },
    // close modal
    closeModal() {
      this.$emit('close');
    },
    // select city add to filter
    addCity(city) {
      if (city.id == '') {
        this.removeFilters();
      } else if (!this.highlightSelectedCities(city)) {
        this.addCitytoFilter(city);
      } else if (this.highlightSelectedCities(city)) {
        this.removeCity(city);
      }
    },
    // remove background of the city when unselected
    removeCity(city) {
      if (this.selectedCities.length == 1) {
        if (city.id == '') return;
        this.removeFilters();
      } else {
        this.removeCityFromFilter(city);
      }
    },
    // remove all filters
    removeFilters() {
      this.removeAllFilters();
    },
    setDefaultFilters() {
      this.addDefaultCitytoFilter({ id: this.cityId, name: this.city });
    },
    // getting all city in the checkbox , getting innerText , cut the string with the searchKeyword.length , then compare to each other , if the city does not contain the searchKeyword return -1 , then change the display to none .
    searchingForCity() {
      const optionsList = document.querySelectorAll('.options');
      const searchKeyword = this.searchKeyword.toLowerCase();
      const searchKeywordLength = this.searchKeyword.length;
      optionsList.forEach((option) => {
        let label = option.firstElementChild.innerText.toLowerCase();
        label = label.slice(0, searchKeywordLength);
        if (label.indexOf(searchKeyword) !== -1) {
          option.classList.add('flex');
          option.classList.remove('hidden');
        } else {
          option.classList.add('hidden');
          option.classList.remove('flex');
        }
      });
    },
  },
  watch: {
    searchKeyword() {
      this.searchingForCity();
    },
  },
};
</script>

<style scoped>
.header {
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: #333333;
}

.clear-all-filters {
  font-size: 10px;
  line-height: 12px;
  text-decoration: underline;
}

.filter-by-city {
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
}

.show-selected-cities {
  width: 100%;
  flex-wrap: wrap;
  max-height: 180px !important;
  overflow-y: auto;
  margin-top: 10px;
  align-items: flex-end;
}

.show-selected-cities div {
  padding: 8px 12px;
  background: rgba(74, 0, 69, 0.05);
  border: 1px solid #dadada;
  box-sizing: border-box;
  border-radius: 3px;
  margin-top: 8px;
  height: 31px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: flex-end;
  color: #4a0045;
}

.show-selected-cities img {
  width: 12px;
  cursor: pointer;
}

.selected-city {
  background: #bd006c;
}

.city-selection {
  border: 1px solid #dadada;
  box-sizing: border-box;
  border-radius: 4px;
  height: 285px;
}

.city-selection .search-input {
  width: 316px;
  margin: 5px auto;
}

.city-selection .show-box-inner {
  height: 231px;
  border-top: 1px solid #dadada;
  border-radius: 0 0 4px 4px;
}

.select-Item p {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #333333;
}

.show-selected-cities {
  width: 100%;
  flex-wrap: wrap;
  max-height: 180px !important;
  overflow-y: auto;
  margin-top: 10px;
  align-items: flex-end;
}

.show-selected-cities div {
  padding: 8px 12px;
  background: rgba(74, 0, 69, 0.05);
  border: 1px solid #dadada;
  box-sizing: border-box;
  border-radius: 3px;
  margin-top: 8px;
  height: 31px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: flex-end;
  color: #4a0045;
}

.show-selected-cities img {
  width: 12px;
  cursor: pointer;
}

::-webkit-scrollbar {
  width: 4px;
  background: #dadada;
  border-radius: 100px;
  margin-right: 20px;
}

::-webkit-scrollbar-thumb {
  background: #979797;
}

.filter-modal {
  height: 618px;
}

@media only screen and (min-width: 319px) and (max-width: 330px) {
  .iphone-head-height {
    height: 5.6rem !important;
  }

  .filter-modal {
    max-height: 600px;
  }
}
</style>
